import { apiSlice, asyncToastDisplay, i18n } from "./apiSlice";

export const dataVendorAudienceApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getDataVendorAudience: builder.query({
      query: ([dataVendorId, audienceKey]) => `/data_vendors/${dataVendorId}/audiences/${audienceKey}`,
      providesTags: (result, error, arg) => [{ type: 'DataVendorAudience', id: arg[1] }],
    }),
    getDataVendorAudiences: builder.query({
      query: (dataVendorId) => `/data_vendors/${dataVendorId}/audiences/`,
      providesTags: (result, error, arg) => [{ type: 'DataVendorAudience', id: 'LIST' }],
    }),
    createDataVendorAudience: builder.mutation({
      query: (audience) => ({
        url: `/data_vendors/${audience.dataVendorId}/audiences/`,
        method: 'POST',
        body: audience
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.created")}),
      invalidatesTags: (result, error, arg) => [
        { type: 'DataVendor', id: arg.dataVendorId },
        { type: 'DataVendorAudience', id: 'LIST' }],
    }),
    updateDataVendorAudience: builder.mutation({
      query: (audience) => ({
        url: `/data_vendors/${audience.dataVendorId}/audiences/${audience.key}`,
        method: 'PUT',
        body: audience,
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.updated")}),
      invalidatesTags: (result, error, arg) => [
        { type: 'DataVendor', id: arg.dataVendorId  },
        { type: 'DataVendorAudience', id: arg.key },
        { type: 'DataVendorAudience', id: 'LIST' }
      ]
    }),
    runDataVendorAudience: builder.mutation({
      query: ([dataVendorId, audienceKey]) => ({
        url: `/data_vendors/${dataVendorId}/audiences/${audienceKey}/run`,
        method: 'POST'
      })
    }),
    deleteDataVendorAudience: builder.mutation({
      query: ([dataVendorId, audienceId]) => ({
        url: `/data_vendors/${dataVendorId}/audiences/${audienceId}`,
        method: 'DELETE'
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.deleted")}),
      invalidatesTags: (result, error, arg) => {
        return [
          { type: 'DataVendor', id: arg.dataVendorId  },
          { type: 'DataVendorAudience', id: arg.audienceId },
          { type: 'DataVendorAudience', id: 'LIST' }
        ]}
    }),
    getDataVendorAudienceAggregationOptions: builder.query({
      query: (dataVendorId) => ({
        url: `/data_vendors/${dataVendorId}/audiences/aggregation_options`
      }),
      providesTags: [{ type: 'AggregationOptions' }],

    })
  }),
  overrideExisting: false
})

export const {
  useGetDataVendorAudienceQuery,
  useGetDataVendorAudiencesQuery,
  useGetDataVendorAudienceAggregationOptionsQuery,
  useCreateDataVendorAudienceMutation,
  useUpdateDataVendorAudienceMutation,
  useDeleteDataVendorAudienceMutation,
  useRunDataVendorAudienceMutation
} = dataVendorAudienceApiSlice
